import { render, staticRenderFns } from "./AboutBar.vue?vue&type=template&id=3e824fb0&scoped=true"
import script from "./AboutBar.vue?vue&type=script&lang=js"
export * from "./AboutBar.vue?vue&type=script&lang=js"
import style0 from "./AboutBar.vue?vue&type=style&index=0&id=3e824fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e824fb0",
  null
  
)

export default component.exports